import { useState, useContext, useEffect } from "react";
import { handleRunnerData } from "../helpers";
import { RunnerContext } from "../Main";
import { Navigate, useNavigate } from "react-router-dom";
import LoginImage from "../assets/login.png";

const COMPANY_CODE_KEY = "company_code";

export default function Login() {
  const navigate = useNavigate();

  const { setRunnerData, runnerData } = useContext(RunnerContext);
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    username: "",
    password: "",
    roleID: 1,
    companyCode: "", // NEW
  });

  // حمل كود الشركة من اللوكال ستوريدج عند بداية التحميل
  useEffect(() => {
    const savedCode = localStorage.getItem(COMPANY_CODE_KEY);
    if (savedCode) {
      setFormState((s) => ({ ...s, companyCode: savedCode }));
    }
  }, []);

  const handleFormDataChange = (e) => {
    setFormState((oldState) => ({
      ...oldState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    // احفظ كود الشركة في اللوكال ستوريدج
    localStorage.setItem(
      COMPANY_CODE_KEY,
      (formState.companyCode || "").trim()
    );

    await handleRunnerData().login(formState, setRunnerData);
    setLoading(false);
  };

  if (runnerData) {
    return <Navigate to={"/"} />;
  }
  if (loading) return <>loading</>;

  return (
    <div className="login-container">
      <img src={LoginImage} alt="login" className="login-image" />

      <form onSubmit={handleSubmit} className="login-form">
        {/* كود الشركة */}
        <div className="form-control">
          <label htmlFor="companyCode" style={{ fontWeight: "bold" }}>
            company code / كود الشركة
          </label>
          <input
            required
            className="scan-container"
            name="companyCode"
            value={formState.companyCode}
            onChange={handleFormDataChange}
          />
        </div>

        {/* اسم المستخدم */}
        <div className="form-control">
          <label htmlFor="username" style={{ fontWeight: "bold" }}>
            username / إسم المستخدم
          </label>
          <input
            required
            className="scan-container"
            name="username"
            value={formState.username}
            onChange={handleFormDataChange}
          />
        </div>

        {/* كلمة المرور */}
        <div className="form-control">
          <label htmlFor="password" style={{ fontWeight: "bold" }}>
            password / كلمة المرور
          </label>
          <input
            required
            name="password"
            className="scan-container"
            type="password"
            value={formState.password}
            onChange={handleFormDataChange}
          />
        </div>

        <button
          type="submit"
          style={{
            backgroundColor: "#00347b",
            color: "white",
            height: "50px",
            fontWeight: "bold",
          }}
        >
          login / تسجيل الدخول
        </button>
      </form>
    </div>
  );
}
